var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgConsultadoria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67px",
    height: "87px",
    viewBox: "0 0 67 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv_consult") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-2320.000000, -437.000000)",
    stroke: "",
    strokeWidth: 5.5434456
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_consult",
    transform: "translate(2323.072608, 440.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0250736,41.7207453 C14.5749679,41.4335112 7.86459069,34.4321822 7.86459069,25.8151604 C7.86459069,17.0186175 14.8945103,9.87367045 23.6286528,9.87367045 C32.3272908,9.87367045 39.3927183,17.0186175 39.3927183,25.8151604 C39.3572137,34.4321822 32.6468322,41.4335112 24.1967266,41.7207453 C23.8416801,41.684841 23.4156247,41.684841 23.0250736,41.7207453 Z",
    id: "Vector",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44409308,76.0452139 C16.2078702,82.6515972 32.2204671,82.6515972 41.9842442,76.0452139 C50.5763683,70.2287244 50.5763683,60.7500017 41.9842442,54.9694164 C32.2559717,48.3989374 16.2433748,48.3989374 6.44409308,54.9694164 C-2.14803103,60.7859059 -2.14803103,70.2646287 6.44409308,76.0452139 Z",
    id: "Vector",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6055728,7.31414855 C44.7985553,1.95759959 48.2503537,-0.456780171 52.9609679,0.0710092624 C60.0268891,0.862693412 63.0569838,6.99270577 57.4338412,13.4715941 C56.1154835,14.8460233 51.3698605,17.6680294 51.6879604,22.4401601",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.8160217,
    y1: 31.8650274,
    x2: 51.2598297,
    y2: 31.8650274,
    id: "Path-4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgConsultadoria);
export default __webpack_public_path__ + "static/media/svg_consultadoria.e2a49e1639e9ac74a8757552241c6f90.svg";
export { ForwardRef as ReactComponent };